import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ChatBubbleOutlineOutlined, CloseOutlined } from '@mui/icons-material';
import { CHAT_COLOR } from './constants';
import { ChatTab } from './ChatTab';

export function ChatModal({ open, onClose, chatHotspots, activeChatHotspot, event }) {
  if (!open) return null;
  return (
    <Box
      onClick={onClose}
      sx={{
        position: 'fixed', inset: 0, zIndex: 1300,
        background: 'rgba(15, 23, 42, 0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        backdropFilter: 'blur(2px)',
      }}
    >
      <Box
        onClick={e => e.stopPropagation()}
        sx={{
          width: '88vw', maxWidth: 1100,
          height: '82vh',
          background: '#fff',
          borderRadius: '16px',
          overflow: 'hidden',
          display: 'flex', flexDirection: 'column',
          boxShadow: '0 24px 80px rgba(0,0,0,0.22)',
        }}
      >
        <Box sx={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          px: 2.5, py: 1.5,
          borderBottom: '1px solid #f0f4f8',
          flexShrink: 0,
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{
              width: 30, height: 30, borderRadius: '8px',
              background: alpha(CHAT_COLOR, 0.1),
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: CHAT_COLOR,
            }}>
              <ChatBubbleOutlineOutlined sx={{ fontSize: 16 }} />
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: '0.88rem', color: '#1a1a2e' }}>
              Live Chat
            </Typography>
            <Box sx={{
              ml: 0.5, px: 0.9, py: 0.25, borderRadius: '5px',
              background: alpha(CHAT_COLOR, 0.1), color: CHAT_COLOR,
              fontSize: '0.65rem', fontWeight: 700,
            }}>
              {chatHotspots.length} channel{chatHotspots.length !== 1 ? 's' : ''}
            </Box>
          </Box>
          <IconButton size="small" onClick={onClose} sx={{ color: '#9ea8b3' }}>
            <CloseOutlined sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        <Box sx={{ flex: 1, overflow: 'hidden' }}>
          <ChatTab
            chatHotspots={chatHotspots}
            activeChatHotspot={activeChatHotspot}
            event={event}
          />
        </Box>
      </Box>
    </Box>
  );
}
